import { useQuery } from '@apollo/client';
import { Container, Text } from '@loomhq/lens';
import React from 'react';

import { getUserAvatarThumb } from 'utilities/avatar';
import { getMostCompleteNamePossible } from 'utilities/user';

import GetUserWithProfileInfo from './profile-card/GetUserWithProfileInfo.graphql';

import UserAvatar from 'components/user-avatar';
import ProfileCard from 'components/user-profile/profile-card';

import styles from './styles.module.less';

export default function UserComponentWithProfileHover({
  profileId,
  type = 'avatar',
  hasFocus,
  avatarSize,
  fontSize,
}) {
  const { loading: userInfoLoading, data: userProfileData } = useQuery(
    GetUserWithProfileInfo,
    {
      variables: {
        userId: profileId,
      },
      fetchPolicy: 'no-cache',
      skip: !profileId,
    }
  );

  if (userInfoLoading) {
    return (
      <>
        {type === 'name' ? (
          <div className={styles.rowLoading}>
            <Container
              height="small"
              width="4.5rem"
              backgroundColor="disabledBackground"
              radius="medium"
            />
          </div>
        ) : (
          <div className={styles.avatarLoading}>
            <Container
              height={avatarSize}
              width={avatarSize}
              backgroundColor="disabledBackground"
            />
          </div>
        )}
      </>
    );
  }

  const user = userProfileData?.user?.user;

  const name = getMostCompleteNamePossible(user);
  const userAvatarSrc = getUserAvatarThumb(user?.avatars);

  return (
    <ProfileCard
      avatarSrc={userAvatarSrc}
      hasFocus={hasFocus}
      name={name}
      profileId={profileId}
      useLoomSSRVideo={false}
      cachedUserProfileData={userProfileData}
    >
      {type === 'name' ? (
        <Container height="1.125rem">
          <Text size={fontSize} fontWeight="medium" hasEllipsis>
            {name}
          </Text>
        </Container>
      ) : (
        <UserAvatar
          avatarSize={avatarSize}
          avatarSrc={userAvatarSrc}
          name={name}
        />
      )}
    </ProfileCard>
  );
}
